import React from "react";
import { useSelector } from "react-redux";
import { fmtHours } from "./exitApi";
import "../../../StyleSheet/MainComponent/ExitWorkflow/ExitWorkflow.scss";

// Page wrapper matching the rest of the admin portal (sidebar-aware content area + header strip).
export function ExitPage({ title, actions, children }) {
  const sidebarOpen = useSelector((state) => state.SideBarActive.SidebarActive);
  return (
    <div className={sidebarOpen ? "outterContent" : "inner-Content"}>
      <div className="exitwf">
        <div className="exitwf-head">
          <h3>{title}</h3>
          <div className="exitwf-head-actions">{actions}</div>
        </div>
        <div className="exitwf-body">{children}</div>
      </div>
    </div>
  );
}

export function Card({ title, right, children, className = "", onTitleClick }) {
  return (
    <section className={`exitwf-card ${className}`}>
      {(title || right) && (
        <div className={`exitwf-card-title ${onTitleClick ? "clickable" : ""}`} onClick={onTitleClick}>
          <span className="t">{title}</span>
          {right}
        </div>
      )}
      {children}
    </section>
  );
}

export function Field({ field, value, onChange, readOnly, error, options, min, max }) {
  const id = `exf-${field.key}`;
  const req = field.required || field.declaration;
  const common = { id, disabled: readOnly, value: value ?? "", onChange: (e) => onChange(field.key, e.target.value), className: "form-control" };
  let control;
  if (field.type === "select") {
    control = (
      <select {...common} className="form-select">
        <option value="">Select</option>
        {(options?.[field.options] || []).map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
    );
  } else if (field.type === "textarea") {
    control = <textarea rows={3} {...common} />;
  } else {
    control = <input type={field.type === "number" ? "number" : field.type === "date" ? "date" : "text"} min={min} max={max} {...common} />;
  }
  return (
    <div className={`exitwf-field ${field.type === "textarea" ? "wide" : ""} ${field.declaration ? "declaration" : ""} ${error ? "has-error" : ""}`}>
      <label htmlFor={id}>
        {field.label}
        {req && <span className="req">*</span>}
      </label>
      {control}
      {error && <div className="err">{error}</div>}
    </div>
  );
}

export function ReadField({ label, value, wide }) {
  return (
    <div className={`exitwf-field ${wide ? "wide" : ""}`}>
      <label>{label}</label>
      <div className="readonly">{value === 0 ? "0" : value || "—"}</div>
    </div>
  );
}

export function StageChip({ status, slaState }) {
  if (status === "done") return <span className="exitwf-chk done">Cleared</span>;
  if (status === "open") return <span className={`exitwf-chk open ${slaState || "ok"}`}>Pending</span>;
  if (status === "skipped") return <span className="exitwf-chk none">Skipped</span>;
  return <span className="exitwf-chk none">--</span>;
}

export function Pill({ kind = "", children }) {
  return <span className={`exitwf-pill ${kind}`}>{children}</span>;
}

export function Stepper({ stages, caseStatus }) {
  const shown = stages.filter((s) => s.status !== "skipped");
  return (
    <ol className="exitwf-stepper">
      {shown.map((s) => {
        const open = s.status === "open" && caseStatus === "open";
        const cls = s.status === "done" ? "done" : open ? `open ${s.sla?.state || ""}` : "wait";
        return (
          <li key={s.stage_key} className={cls}>
            <span className="dot">{s.status === "done" ? "✓" : ""}</span>
            <b>{s.label}</b>
            <small>
              {s.status === "done"
                ? `${fmtHours(s.sla?.hours)} · SLA ${s.sla?.sla_hours}h`
                : open
                ? `${fmtHours(s.sla?.hours)} of ${s.sla?.sla_hours}h${s.sla?.state === "breach" ? " · overdue" : ""}`
                : "Not started"}
            </small>
          </li>
        );
      })}
    </ol>
  );
}

export function Modal({ title, onClose, children, footer, wide }) {
  return (
    <div className="exitwf-modal-back" onClick={onClose}>
      <div className={`exitwf-modal ${wide ? "wide" : ""}`} onClick={(e) => e.stopPropagation()} role="dialog" aria-label={title}>
        <div className="exitwf-modal-head">
          {title}
          <button className="x" aria-label="Close" onClick={onClose}>×</button>
        </div>
        <div className="exitwf-modal-body">{children}</div>
        {footer && <div className="exitwf-modal-foot">{footer}</div>}
      </div>
    </div>
  );
}
